import { reactive } from 'vue'

const globalLoading = reactive({
  visible: false,
  message: 'Loading in progress...',
  progress: null
})

export function useGlobalLoading() {
  const show = (message = 'Loading in progress...', progress = null) => {
    globalLoading.visible = true
    globalLoading.message = message
    globalLoading.progress = progress
  }

  const hide = () => {
    globalLoading.visible = false
    globalLoading.progress = null
  }

  const updateMessage = (message) => {
    globalLoading.message = message
  }

  const updateProgress = (progress) => {
    globalLoading.progress = progress
  }

  const withLoading = async (asyncFunction, message = 'Loading in progress...') => {
    show(message)
    try {
      return await asyncFunction()
    } finally {
      hide()
    }
  }

  return {
    globalLoading,
    show,
    hide,
    updateMessage,
    updateProgress,
    withLoading
  }
}